import { ThemedFunctor, TokenColor } from '@doveit/bricks';
import { css } from 'styled-components';

export const noWrap: ThemedFunctor = ({ theme, $highlightColor }) => {
  const color = $highlightColor as keyof TokenColor['foreground'];
  return css`
  white-space: nowrap;

    ${$highlightColor && css`
      color: ${theme.color.foreground[color].default.low};
    `}
  `;
};
